import { UserTypes } from 'types/GlobalTypes';
import { getColor } from 'utilities/SystemUtils';
import AppChip from './AppChip';

export const AppUserTypeChip = ({ userType }: { userType: UserTypes | null }) => (
  <AppChip value={userType} getColor={getColor} />
);

export default AppUserTypeChip;
